import { classEnum } from "./base";

export const DismantleStatusEnum = new (class extends classEnum([
    {
        label: "Menunggu",
        value: "W", // Waiting
    },
    {
        label: "Pelepasan",
        value: "DI", // Dismantle
    },
    {
        label: "Finalisasi",
        value: "F", // Finalization
    },
    {
        label: "Selesai",
        value: "D", // Done
    },
    {
        label: "Dibatalkan",
        value: "C", // Canceled
    },
]) {
    public get valuesOngoing() {
        return this.values.filter((v) => v !== "C" && v !== "D");
    }

    public get ValuesOngoing(): this["valuesOngoing"][number] {
        throw new Error("ValuesOngoing can't be used as a value");
    }
})();

export namespace DismantleStatusEnum {
    export type Labels = (typeof DismantleStatusEnum)["labels"][number];
    export type Values = (typeof DismantleStatusEnum)["values"][number];
    export type ValuesOngoing = (typeof DismantleStatusEnum)["valuesOngoing"][number];
}
